import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, Stack } from '@mui/material';
import { ReactComponent as CloseMessage } from './images/close-message.svg';
import * as helpers from './helpers';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import jpgIconForModal from './images/jpgIconForModal.png';
import pdfIconForModal from './images/pdfIconForModal.png';
import CircleIcon from '@mui/icons-material/Circle';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import ImagePreviewModal from './ImagePreviewModal';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CardActions, useMediaQuery } from '@mui/material';
import { ClipLoader } from 'react-spinners';

const FileModal = ({ open, handleClose, activeLayerId, documentsJSON }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [fileTypeError, setFyleTypeError] = useState(false);
  const [addingFileInProgress, setAddingFileInProgress] = useState(false);
  const [newFilesForUpload, setNewFilesForUpload] = useState([]);
  const [documentsArr, setDocumentsArr] = useState([]);
  const [activeLayerName, setActiveLayerName] = useState('');
  const [folderName, setFolderName] = useState('');
  const [openImageModal, setOpenImageModal] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [fileToDelete, setFileToDelete] = useState({});

  const allowedFyleTypes = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/pdf',
  ];
  const isFullSize = useMediaQuery('(min-width:600px)');
  const isMobile = useMediaQuery('(max-width:600px)');
  const isXSMobile = useMediaQuery('(max-width:420px)');

  const uploadButtonBoxStyle = {
    height: isFullSize ? 100 : isXSMobile ? 74 : 86,
    width: isFullSize ? 100 : isXSMobile ? 74 : 86,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    p: 2,
    border: '1px solid #e0e2f9',
    borderRadius: '7px',
  };

  const boxStyle = {
    height: isFullSize ? 100 : isXSMobile ? 74 : 86,
    width: isFullSize ? 100 : isXSMobile ? 74 : 86,
    gap: 4,
    p: 2,
    border: '1px solid #e5e1e1',
    borderRadius: '7px',
  };

  const iconsBoxStyle = {
    height: '52px',
    width: '55px',
    borderRadius: '7px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  useEffect(() => {
    setLayerProperties();
    if (documentsJSON && documentsJSON !== '') {
      setDocumentsArr(JSON.parse(documentsJSON));
    }
  }, []);

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newFiles = [];

    if (files.length === 0) return;

    Array.from(files).forEach((file) => {
      if (allowedFyleTypes.includes(file?.type) && file?.size < 10485760) {
        newFiles.push(file);
      } else {
        setFyleTypeError(true);
        setOpenSnackBar(true);
      }
    });

    if (newFiles) {
      setNewFilesForUpload((arr) => [...arr, ...newFiles]);
    }
  };

  const handleNewFilesAdded = async () => {
    if (activeLayerName === '' || folderName === '') setLayerProperties();
    setAddingFileInProgress(true)
    const data = await helpers.uploadDocuments(newFilesForUpload, folderName);

    if (data && data.statusCode === 201) {
      const updateDocumentsData = documentsArr
        ? documentsArr.concat(data.documents)
        : data.documents;
      const updateRes = await helpers.updateDocumentsXML(
        activeLayerName,
        activeLayerId,
        updateDocumentsData
      );
      if (updateRes.status === 200) {
        setDocumentsArr(updateDocumentsData);
        setAddingFileInProgress(false)
        setNewFilesForUpload([]);
      }
    }
    setAddingFileInProgress(false)
  };

  const handleDelete = async () => {
    if (activeLayerName === '' || folderName === '') setLayerProperties();

    if (!fileToDelete) return;

    const deleteObj = {
      folder: folderName,
      filename: fileToDelete.newName
    }

    const response = await helpers.deleteDocument(deleteObj);

    if (response.statusCode === 200) {

      const updatedDocumentsArr =
        documentsArr.filter((val) => {
          return val.newName !== fileToDelete.newName;
        });

      const updateRes = await helpers.updateDocumentsXML(
        activeLayerName,
        activeLayerId,
        updatedDocumentsArr
      );
      if (updateRes.status === 200) {
        setDocumentsArr(updatedDocumentsArr);
        setFileToDelete({})
      }

    }
  };

  const handleOpenConfirmationDialog = (file) => {
    setFileToDelete(file)
    setOpenConfirmationDialog(true);
  };

  const handleCloseConfirmationDialog = (resClick) => {
    setOpenConfirmationDialog(false);
    if (resClick) {
      handleDelete();
    }
    setFileToDelete({})
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
    setFyleTypeError(false);
  };

  const setLayerProperties = () => {
    const layerNameWithoudId = activeLayerId.split('.')[0];
    const layerName = layerNameWithoudId.toLowerCase().split(' ').join('_');
    const folder = layerName.toLowerCase().split(' ').join('_');
    setActiveLayerName(layerName);
    setFolderName(folder);
  };

  const formatDate = (uploadTime) => {
    const date = new Date(uploadTime);
    let formatedDate =
      date.getDate() +
      '.' +
      parseInt(date.getMonth() + 1) +
      '.' +
      date.getFullYear() +
      '.';
    return formatedDate;
  };

  const handleOpenImageModal = (fileType, fileName) => {
    if (folderName === '') setLayerProperties();

    const geoUrl = process.env.REACT_APP_GEOSERVER;

    const url = `${geoUrl}/static/${folderName + '/' + fileName}`;
    setFileUrl(url);

    if (fileType === 'pdf') {
      window.open(url, '_blank');
    } else {
      setOpenImageModal(true);
    }
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
  };

  return (
    <Modal
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '10px',
        marginRight: '10px',
      }}
      aria-modal={true}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          width: '600px',
          backgroundColor: 'white',
          borderRadius: '15px',
          overflow: 'hidden',
          paddingBottom: '16px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 2,
            backgroundColor: '#21538F',
            color: 'white',
            height: '1rem',
          }}
        >
          <Typography variant="h7">Datoteke</Typography>
          <div
            className="header-button"
            style={{ marginRight: '0' }}
            onClick={handleClose}
          >
            <CloseMessage style={{ height: '10px' }} />
          </div>
        </Box>
        <Box
          padding={2}
          sx={{
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
            gap: '10px',
            paddingBottom: '0',
          }}
        >
          {documentsArr &&
            documentsArr.map((file, index) => (

              <Box sx={boxStyle} key={index}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Stack>
                    <CardActions
                      key={index}
                      onClick={() => handleOpenImageModal(file.type, file.newName)}
                      sx={{ cursor: 'pointer', padding: 0 }}
                      disableSpacing={true}
                      type="button"
                    >
                      <Box
                        sx={iconsBoxStyle}
                        backgroundColor={
                          file.type === 'pdf' ? '#ffdbdb' : '#c6f7c8'
                        }
                      >
                        <img
                          src={
                            file.type === 'pdf'
                              ? pdfIconForModal
                              : jpgIconForModal
                          }
                          alt=""
                          width="22px"
                          height="28px"
                        />
                      </Box>
                    </CardActions>
                  </Stack>
                  <Stack>
                    <div
                      style={{
                        paddingTop: isXSMobile ? '0' : '4px',
                        textAlign: 'center',
                      }}
                    >

                      <p
                        style={{
                          width: isFullSize
                            ? '110px'
                            : isXSMobile
                              ? '95px'
                              : '105px',
                          fontSize: isXSMobile ? '14px' : '16px',
                          margin: '0',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          height: '25px',
                        }}
                      >
                        {file.originalName}
                      </p>
                    </div>
                  </Stack>

                  <Stack sx={{ width: isXSMobile ? '95px' : '110px' }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: isFullSize
                        ? '12px'
                        : isXSMobile
                          ? '-8px'
                          : '2px',
                    }}>
                      <div>
                        <IconButton
                          onClick={() => handleOpenConfirmationDialog(file)}
                          sx={{ p: 0, mb: '3px' }}
                        >
                          <DeleteIcon sx={{ color: '#db1616b8', width: '20px', height: '20px' }} />
                        </IconButton>
                      </div>
                      <p
                        style={{
                          color: '#b1b1b1',
                          fontSize: isXSMobile ? '11px' : '12px',
                          margin: 0
                        }}
                      >
                        {formatDate(file.uploadTime)}
                      </p>
                    </div>
                  </Stack>
                </Stack>
              </Box>

            ))}
          {newFilesForUpload &&
            newFilesForUpload.map((file, index) => (
              <Box sx={boxStyle} key={index}>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Stack>
                    <Box
                      sx={iconsBoxStyle}
                      backgroundColor={
                        file.type === 'application/pdf' ? '#ffdbdb' : '#c6f7c8'
                      }
                    >
                      <img
                        src={
                          file.type === 'application/pdf'
                            ? pdfIconForModal
                            : jpgIconForModal
                        }
                        alt=""
                        width="22px"
                        height="28px"
                      />
                    </Box>
                  </Stack>
                  <Stack>
                    <div
                      style={{
                        paddingTop: isXSMobile ? '0' : '4px',
                        textAlign: 'center',
                      }}
                    >
                      <p
                        style={{
                          width: isFullSize
                            ? '110px'
                            : isXSMobile
                              ? '95px'
                              : '105px',
                          fontSize: isXSMobile ? '14px' : '16px',
                          margin: '0',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          height: '25px',
                        }}
                      >
                        {file.name}
                      </p>
                    </div>
                  </Stack>
                  <Stack
                    sx={{
                      width: '110px',
                      marginRight: isXSMobile ? '-8px' : '6px',
                    }}
                  >
                    <p
                      style={{
                        color: '#f1b207',
                        fontSize: isMobile ? '11px' : '12px',
                        display: 'flex',
                        flexDirection: 'row',
                        marginTop: isFullSize
                          ? '12px'
                          : isXSMobile
                            ? '-3px'
                            : '3px',
                      }}
                    >
                      <CircleIcon
                        sx={{
                          fontSize: 15,
                          marginRight: isXSMobile ? '1px' : '3px',
                          paddingTop: '1px',
                        }}
                        viewBox="2 0 20 24"
                      />
                      Nije sačuvano
                    </p>
                  </Stack>
                </Stack>
              </Box>
            ))}
          <Box sx={uploadButtonBoxStyle}>
            <label style={{ cursor: 'pointer' }}>
              <AddCircleIcon sx={{ fontSize: 55 }} color="primary" />
              <input
                type="file"
                accept="image/jpeg,image/png,application/pdf"
                hidden
                multiple
                onChange={handleFileChange}
              />
            </label>
          </Box>
          <ImagePreviewModal
            imageUrl={fileUrl}
            open={openImageModal}
            onClose={handleCloseImageModal}
          />
          <Dialog
            open={openConfirmationDialog}
            onClose={() => handleCloseConfirmationDialog(false)}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              Brisanje Datoteke
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Jeste li sigurni da želite obrisati ovu datoteku?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button sx={{ background: '#a9a6a6', color: 'white' }} autoFocus onClick={() => handleCloseConfirmationDialog(false)}>
                Otkaži
              </Button>
              <Button sx={{ background: '#e73535', color: 'white' }} onClick={() => handleCloseConfirmationDialog(true)} autoFocus>
                Obriši
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={openSnackBar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={4000}
            onClose={handleCloseSnackBar}
          >
            <Alert
              onClose={handleCloseSnackBar}
              severity={fileTypeError ? 'error' : 'success'}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {fileTypeError
                ? `Greška! Neki od dodanih fajlova su nedozvoljenog formata!`
                : `Uspješno ste dodali novi fajl!`}
            </Alert>
          </Snackbar>
        </Box>
        {newFilesForUpload.length !== 0 && (
          <Stack padding={1} sx={{ paddingBottom: '0', paddingTop: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                className="file-modal-button"
                ariant="contained"
                tabIndex={-1}
                onClick={handleNewFilesAdded}
                disabled={addingFileInProgress}
              >
                Sačuvaj Promjene
              </Button>
              {addingFileInProgress &&
                <div style={{ paddingLeft: '6px', paddingTop: '2px' }}>
                  <ClipLoader
                    color={'primary'}
                    loading={addingFileInProgress}
                    size={30}
                    data-testid="loader"
                  />
                </div>
              }
            </div>
          </Stack>
        )}
      </Box>
    </Modal>
  );
};

export default FileModal;